module.exports = __webpack_public_path__ + "static/media/AppleStore.7c7c205c.svg";